import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default async function getMovimentoContato(ContatoId: any) {
  const result = await api.get(`${URLS.CONTATO_MOVIMENTO_API}`, {
    params: {ContatoId}
  })
  .then((resp => resp.data));
  return result;
}
